import { IntlShape } from 'react-intl';

import {
  OrganizationExtraDetailsState,
  validateExtraDetails,
} from 'app/configuration/organizations/organization-extra-details';

// The extra-details keys are only present in the edit form, once they were
// loaded from the Express API. When they are absent they are neither validated
// nor sent.
export interface OrganizationFormState
  extends Partial<OrganizationExtraDetailsState> {
  englishName: string;
  arabicName: string;
  status?: boolean;
}

interface Errors {
  [key: string]: string;
}

const validateOrganizationForm = (
  values: OrganizationFormState,
  intl: IntlShape,
  allowEmptyKind = false
): Errors => {
  const errors: Errors = {};

  const validationRequiredMessage = intl.formatMessage({
    id: 'requiredValidation',
  });

  if (!values.arabicName) {
    errors.arabicName = validationRequiredMessage;
  }

  if (!values.englishName) {
    errors.englishName = validationRequiredMessage;
  }

  if (values.currency !== undefined) {
    Object.assign(
      errors,
      validateExtraDetails(
        values as OrganizationExtraDetailsState,
        intl,
        allowEmptyKind
      )
    );
  }

  return errors;
};

export { validateOrganizationForm };
